import client from "./http.client"
import store from "@/store"
class ControlService {
  async getMenus() {
    return client.get(`/api/organizations/${store.state.organization.id}/menu/`)
  }
  async getPermissions() {
    return client.get(`/api/organizations/${store.state.organization.id}/permissions/`, { page_size: 1000 })
  }
  async getRoles() {
    return client.get(`/api/organizations/${store.state.organization.id}/roles/`, { page_size: 1000 })
  }
  updateRole(id, data) {
    return client.patch(`/api/organizations/${store.state.organization.id}/roles/${id}/`, data)
  }
  addRole(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/roles/`, data)
  }
  setPlatformOptions(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/set-option-metric/`, data)
  }
}

export default new ControlService()
